<style>
.tel-input-template
.ivu-dropdown .ivu-select-dropdown {
  left: 0 !important;
  top: 22px !important;
}
.tel-input-template
.ivu-input-group-append, .ivu-input-group>.ivu-input:last-child {
  padding-left: 50px;
  box-shadow: none;
}
.tel-input-template
.ivu-input-group-prepend {
  border-radius: 4px;
}
.tel-input-template
.ivu-input-group-prepend .ivu-dropdown .ivu-btn {
  border: none;
  border-radius: 0;
}
.tel-input-template
.ivu-input-group-prepend .ivu-dropdown .ivu-btn:focus {
  box-shadow: none;
  background: #ddd;
}
</style>

<style scoped>
.dropdown-btn {
  padding: 5px;
  line-height: 10px;
}
.dropdown-btn-item {
  object-fit: cover;
  display: flex;
  justify-content: start;
  align-items: center;
}
.dropdown-btn-item > img,
.ivu-dropdown-item > img {
  height: 14px;
  width: 25px;
  margin: 0 auto;
  vertical-align: middle;
}
.ivu-icon {
  line-height: 10px;
  vertical-align: middle;
}
.ivu-dropdown-menu {
  max-height: 190px;
  overflow-y: scroll;
  overflow-x: hidden;
  margin-bottom: 0;
  text-align: start;
}
.ivu-dropdown-item {
  white-space: normal;
  max-height: 250px;
  object-fit: cover;
}
.input-dial-code {
  position: absolute;
  top: 1px;
  left: 80px;
  line-height: 24px;
  z-index: 2;
  font-size: 12px;
  padding: 0 5px;
  text-align: end;
  width: 50px;
  font-weight: bold;
  color: #495060;
}
.code-border {
  border-right: 1px solid #dddee1;
  height: 24px;
}
.input-default {
  border-radius: 4px;
  box-shadow: none;
  transition: box-shadow 0.3s ease-in-out;
}
.no-flag {
  left: 50px;
}
</style>

<template>
  <div class="tel-input-template" style="position:relative">
    <Row><Col :span="24">
      <Input class="input-default" v-model="mobile_number" @on-change="onInput" :style="isActive"
      size="small" :placeholder="placeholder" :name="name">
        <Dropdown trigger="click" placement="bottom-start" slot="prepend">
          <Button class="dropdown-btn">
            <span class="dropdown-btn-item">
              <!-- <img alt=" " v-if="activeCountry && isPH(activeCountry.icon)" :src="activeCountry.icon" width="25px"/> -->
              <strong style="margin:0 5px;width:22px">{{ activeCountry.iso2 }}</strong>
              <Icon type="arrow-down-b"></Icon>
            </span>
          </Button>
          <DropdownMenu slot="list">
            <DropdownItem v-for="pb in allCountries" :key="pb['iso2']"
              :name="pb['iso2']"
              @click.native="choose(pb)">
              <!-- <img alt=" " v-if="pb && isPH(pb.icon)" :src="pb.icon" style="marginRight: 5px"/> -->
              <strong>{{ pb.name }} </strong>
              <span>+{{ pb.dialCode }}</span>
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </Input>
      <span v-if="activeCountry.dialCode" class="no-flag" :class="{'input-dial-code': true}" style="font-size:15px">
        +{{ activeCountry.dialCode }}
        <span class="code-border"></span>
      </span>
    </Col></Row>
  </div>
</template>

<script>
import { format, AsYouType, isValidNumber } from 'libphonenumber-js';
import { getNumberType } from 'libphonenumber-js/custom';
import metadata from 'libphonenumber-js/metadata.full.json'
import allCountries from './assets/all-countries';
import getCountry from './assets/default-country';
export default {
  name: 'TelInput',
  props: {
    value: {
      type: String,
    },
    placeholder: {
      type: String,
      required: false,
      default: 'Enter your mobile no.'
    },
    name: {
      type: String,
      required: false,
      default: ''
    }
  },
  data() {
    return {
      mobile_number: '',
      allCountries,
      activeCountry: { iso2: '' },
      defaultInput: {
        'box-shadow': 'none'
      },
      validInput: {
        'box-shadow': '0 0 0 2px rgba(0,214,10,0.5)'
      },
      invalidInput: {
        'box-shadow': '0 0 0 2px rgba(255,0,0,0.8)'
      }
    }
  },
  methods: {
    findCountry(iso2){
      return allCountries.find(country => country.iso2 === iso2) ||
        allCountries[0];
    },
    choose(country) {
      this.resetNum();
      this.activeCountry = country;
      this.$emit('onTelInput', this.response);
    },
    setNumber(country, number) {
      this.mobile_number = number
      this.activeCountry = country;
      this.$emit('onTelInput', this.response);
    },
    onInput() {
      this.$emit('input',  this.response.number);
      this.$emit('onTelInput', this.response);
    },
    resetNum() {
      this.mobile_number = ''
    },
    validateNum() {
      let num     = this.mobile_number,
      reg         = new RegExp('[^+?0-9]','g').exec(num);
      return (this.mobile_number !== '' && !reg);
    },
    isPH(country) {
      if (country) return (country.includes('PH' || 'ph'))
    }
  },
  computed: {
    mode: {
      get() {
        if (!this.mobile_number) {
          return '';
        }
        if (this.mobile_number[0] === '+') {
          return 'code';
        }
        if (this.mobile_number[0] === '0') {
          return 'prefix';
        }
        return 'normal';
      }
    },
    formattedResult: {
      get() {
        if (!this.mode || !this.allCountries) return '';
        let phone = this.mobile_number;
        if (this.mode === 'code') {
          const formatter = new AsYouType();
          formatter.input(this.mobile_number);

          this.activeCountry = this.allCountries.find(ele =>
            ele.iso2.toUpperCase() === formatter.country) || this.activeCountry;
        } else if (this.mode === 'prefix') {
          phone = this.mobile_number.slice(1);
        }
        return format(phone, this.activeCountry && this.activeCountry.iso2, 'International');
      }
    },
    isTestNum: {
      get() {
        // return (this.mobile_number.substring(0, 3).includes('555') && !(this.mobile_number.length > 11))
        return (this.mobile_number.substring(0, 6).includes('123456') && !(this.mobile_number.length > 10))
      }
    },
    state: {
      get() {
        // let initial = isValidNumber(this.formattedResult) && getNumberType(this.formattedResult, metadata).toString().includes('MOBILE')
        let initial = isValidNumber(this.formattedResult)
        if (!initial && this.isTestNum) {
          return (this.validateNum() && (!initial && this.isTestNum))
        } else {
          return (this.validateNum() && initial);
        }
      }
    },
    response: {
      get() {
        const number = this.formattedResult && this.formattedResult.replace(/ /g, '');
        return {
          number,
          isValid: this.state,
          country: this.activeCountry.name,
        };
      }
    },
    isActive : {
      get() {
        if (!this.mobile_number) {
          return this.defaultInput
        }
        if (this.state) {
          return this.validInput
        } else {
          return this.invalidInput
        }
      }
    }
  },
  mounted() {
    this.activeCountry = allCountries.find(country => country.iso2 === 'US')
  },
  created() {
    if (this.value) {
      this.mobile_number = this.value
    }
  }
}
</script>
